module.exports = {"pathContext":{"name":"MessageSender","kind":"UNION","type":"OBJECT","fields":null,"description":"A sender of a message, either a provider, client, rdvm or an associate","enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"Client","ofType":null},{"kind":"OBJECT","name":"Coowner","ofType":null},{"kind":"OBJECT","name":"Provider","ofType":null},{"kind":"OBJECT","name":"Rdvm","ofType":null}]}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/union-message-sender.json
// module id = 2143
// module chunks = 149058690096730